module.exports = __webpack_public_path__ + "img/photo.be315979.png";